// extracted by mini-css-extract-plugin
export default {"image":"BundleImage-image-hTR"};